// ===========================================
// An onboarding check-in's state (enquiries Phase 6): the SERVER decides it, this names it
// ===========================================

import { Chip } from '@mui/material';
import type { SettlingInState } from '../../../api/settlingIn.api';
import { brandColors, statusColors } from '../../../styles/brandColors';

export const SETTLING_IN_STATE_LABELS: Record<SettlingInState, string> = {
  NOT_SCHEDULED: 'Not scheduled',
  IN_PROGRESS: 'In progress',
  DUE_TODAY: 'Due today',
  OVERDUE: 'Overdue',
  DONE: 'Done',
};

/** Flat chips with dark text (WCAG AA), from the brand tokens. */
const STATE_COLORS: Record<SettlingInState, { bg: string; text: string }> = {
  NOT_SCHEDULED: { bg: statusColors.mutedBg, text: brandColors.textPrimary },
  IN_PROGRESS: { bg: statusColors.infoBg, text: brandColors.textPrimary },
  DUE_TODAY: { bg: statusColors.pendingBg, text: brandColors.textPrimary },
  OVERDUE: { bg: statusColors.warningBg, text: brandColors.textPrimary },
  DONE: { bg: statusColors.successBg, text: brandColors.textPrimary },
};

export default function SettlingInStateChip({ state }: { state: SettlingInState }) {
  const colors = STATE_COLORS[state];
  return (
    <Chip
      size="small"
      label={SETTLING_IN_STATE_LABELS[state]}
      data-testid="settling-in-state"
      sx={{ bgcolor: colors.bg, color: colors.text, fontWeight: 600 }}
    />
  );
}
